import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useCart } from './CartContext';
interface WhatsAppButtonProps {
  text?: string;
  className?: string;
  href?: string;
}
export function WhatsAppButton({
  text = 'Sí, quiero mi pack ahora',
  className = '',
  href
}: WhatsAppButtonProps) {
  const {
    openCart
  } = useCart();
  return <button onClick={openCart} className={`cta-push-button group relative flex items-center justify-center w-full max-w-md mx-auto bg-[#FFD814] text-black font-black text-lg md:text-xl py-4 px-6 rounded-2xl border-2 border-[#FCD200] pt-[12px] pb-[12px] ${className}`} data-id="element-275">
      <span className="tracking-wide" data-id="element-276">{text}</span>
      <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-277" />
    </button>;
}